
import React from 'react';
import Navbar from './Components/Navbar/Navbar';
import './Components/Navbar/Navbar.css'

import Banner from './Components/Banner/Banner';

import Product from './Components/Product/Product';
import Testimonials from './Components/Testimonials/Testimonials';
import News from './Components/News/News';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Banner/>
      <Product/>
     <Testimonials/>
     <News/>
     <Footer/>

    </div>
  );
}

export default App;

